module.exports = __webpack_public_path__ + "img/employee.96fdb852.svg";